import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { GET_VERSOES_PBI_INIT, UPDATE_STATUS_VERSAO_PBI_INIT } from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { getVersoesPbiSuccess, updateStatusVersaoPbiSuccess, errorDefinicoesPbiMsg } from './actions';
import { obtemVersoesPbi, atualizarStatusVersaoPbi } from 'src/integracoes/servicos/mongo-atlas/funcoes/definicoesPbi';

// Obter versões PBI -------------------------
const fetchVersoesPbi = async () => {
  try {
    const { status, dados, mensagem } = await obtemVersoesPbi();
    if (status && Array.isArray(dados)) return { isError: false, dados, errorMessage: null };
    return { isError: true, dados: [], errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseVersoesPbi() {
  try {
    const { isError, dados, errorMessage } = yield call(fetchVersoesPbi);
    if (!isError) {
      yield put(getVersoesPbiSuccess({ versoesPbi: dados }));
    } else {
      yield put(errorDefinicoesPbiMsg({ msg: errorMessage || 'Erro ao carregar versões' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorDefinicoesPbiMsg({ msg: mensagem }));
  }
}

function* watchGetVersoesPbi() {
  yield takeEvery(GET_VERSOES_PBI_INIT, parseVersoesPbi);
}

// Atualizar status versão PBI -------------------------
const fetchUpdateStatus = async (versao: string, statusVersao: string) => {
  try {
    const { status, mensagem } = await atualizarStatusVersaoPbi(versao, statusVersao);
    if (status) return { isError: false, errorMessage: null };
    return { isError: true, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseUpdateStatusVersao(action: any) {
  try {
    const { versao, statusVersao } = action.payload;
    const { isError, errorMessage } = yield call(fetchUpdateStatus, versao, statusVersao);
    if (!isError) {
      yield put(updateStatusVersaoPbiSuccess({ versao, statusVersao }));
    } else {
      yield put(errorDefinicoesPbiMsg({ msg: errorMessage || 'Erro ao atualizar status' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorDefinicoesPbiMsg({ msg: mensagem }));
  }
}

function* watchUpdateStatusVersao() {
  yield takeEvery(UPDATE_STATUS_VERSAO_PBI_INIT, parseUpdateStatusVersao);
}

// WATCHS ------------------------------------------------
export default function* definicoesPbiSaga() {
  yield all([fork(watchGetVersoesPbi), fork(watchUpdateStatusVersao)]);
}
